// TODO överväg att flytta ut denna styling ur /components eftersom det är en extern komponent som används - titta på tooltip-cssen för inspiration
export const modalStyle = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0, 0.5)",
  },
  content: {
    position: "absolute",
    top: "20%",
    left: "6%",
    right: "6%",
    bottom: "10%",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "10px",
  },
};
